import React from 'react';
//import { Divider } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux';
import { useDispatch } from 'react-redux';
import { updateFormatOption } from '../../../redux/ChartPoperties/ChartControlsActions';
import PercentageCalculateButtons from './gaugeChartComponents/PercentageCalculateButtons';
import CurrencyInput from './gaugeChartComponents/CurrencyInput';
import RoundOffComponent from './gaugeChartComponents/RoundOffComponents';

/**
 *
 * @returns Individual formatting UI for measure and label in Gauge chart
 */
const GaugeChartFormatting = ({
  iconColor,
  backgroundColor,
}: {
  iconColor?: string;
  backgroundColor?: string;
}) => {
  const { gaugeChartFormats, propKey } = useSelector((state: RootState) => {
    const tabTileProps = state.tabTileProps;
    const propKey = `${tabTileProps.selectedTabId}.${tabTileProps.selectedTileId}`;
    const gaugeChartFormats =
      state.chartControls.properties[propKey]?.formatOptions?.gaugeChartFormats;

    return { tabTileProps, gaugeChartFormats, propKey };
  });

  const dispatch = useDispatch();

  const formatOptions: any[] = [
    { type: 'Number', value: 'Number' },
    { type: 'Currency', value: 'Currency' },
    { type: 'Percent', value: 'Percent' },
  ];

  //--------format options will be same for label and Number------------//
  const renderFormatOptions = () => {
    return formatOptions.map((item: any) => {
      const currentFormat = gaugeChartFormats?.measureFormat?.formatValue || 'Number';
      const isSelected = item.value === currentFormat;

      return (
        <div
          key={item.value}
          className={isSelected ? 'radioButtonSelected' : 'radioButton'}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
          }}
          onClick={() => {
            let updatedMeasureFormat = {
              ...(gaugeChartFormats?.measureFormat || {}),
              formatValue: item.value,
            };
            if (item.value === 'Percent') {
              updatedMeasureFormat.numberSeparator = 'None';
            }
            if (item.value === 'Currency') {
              if (!updatedMeasureFormat.currencySymbol) {
                updatedMeasureFormat.currencySymbol = '$';
              }
            }
            dispatch(
              updateFormatOption(
                propKey,
                'gaugeChartFormats',
                'measureFormat', // This is the correct key
                updatedMeasureFormat,
              ),
            );
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  const separatorOptions: any[] = [
    { type: 'None', value: 'None' },
    { type: 'Comma', value: 'Comma' },
    { type: 'Abbrev', value: 'Abbrev' },
  ];

  //----------separators can be different for measure & label ----------------//
  const renderSeparatorOptions = (searchIn: string) => {
    return separatorOptions.map((item: any) => {
      const isSelected = item.value === gaugeChartFormats?.[searchIn]?.numberSeparator;
      return (
        <div
          key={item.value}
          style={{
            backgroundColor: isSelected ? 'rgba(224, 224, 224, 1)' : 'white',
            cursor: isSelected ? 'auto' : 'pointer',
            fontWeight: isSelected ? '600' : 'normal',
          }}
          className="radioButton"
          onClick={() => {
            if (gaugeChartFormats?.measureFormat?.formatValue === 'Percent') return;
            const updatedValue = {
              ...(gaugeChartFormats?.[searchIn] || {}),
              numberSeparator: item.value,
            };
            dispatch(updateFormatOption(propKey, 'gaugeChartFormats', searchIn, updatedValue));
          }}
        >
          {item.type}
        </div>
      );
    });
  };

  return (
    <>
      <div
        className="optionDescription"
        style={{
          marginTop: '10',
          marginBottom: '0px',
          color: iconColor,
        }}
      >
        FORMAT
      </div>
      <div style={{ marginBottom: '10px' }}>
        <div className="optionDescription" style={{ marginTop: '0px', color: iconColor }}>
          Format Value
        </div>
        <div className="radioButtons" style={{ padding: '0' }}>
          {renderFormatOptions()}
        </div>
      </div>

      {gaugeChartFormats?.measureFormat?.formatValue === 'Percent' ? (
        <PercentageCalculateButtons
          searchIn="measureFormat"
          propKey={propKey}
          iconColor={iconColor}
        />
      ) : null}

      {gaugeChartFormats?.measureFormat?.formatValue === 'Currency' && (
        <CurrencyInput searchIn="measureFormat" propKey={propKey} iconColor={iconColor} />
      )}

      {gaugeChartFormats?.measureFormat?.formatValue !== 'Percent' && (
        <>
          <div className="optionDescription" style={{ marginTop: '0.1rem', color: iconColor }}>
            Separator
          </div>
          <div className="radioButtons" style={{ paddingLeft: '0.1rem', margin: 'auto' }}>
            {renderSeparatorOptions('measureFormat')}
          </div>
        </>
      )}

      <RoundOffComponent
        searchIn="measureFormat"
        propKey={propKey}
        iconColor={iconColor}
        backgroundColor={backgroundColor}
      />
    </>
  );
};
export default GaugeChartFormatting;
